/**
 * Design System Spacing Tokens
 * Based on 4px grid system for consistent spacing
 */

// Base unit
const SPACING_UNIT = 4;

// Spacing scale
export const spacing = {
  0: '0',
  px: '1px',
  0.5: `${SPACING_UNIT * 0.5}px`,  // 2px
  1: `${SPACING_UNIT * 1}px`,      // 4px
  2: `${SPACING_UNIT * 2}px`,      // 8px
  3: `${SPACING_UNIT * 3}px`,      // 12px
  4: `${SPACING_UNIT * 4}px`,      // 16px
  5: `${SPACING_UNIT * 5}px`,      // 20px
  6: `${SPACING_UNIT * 6}px`,      // 24px
  8: `${SPACING_UNIT * 8}px`,      // 32px
  10: `${SPACING_UNIT * 10}px`,    // 40px
  12: `${SPACING_UNIT * 12}px`,    // 48px
  16: `${SPACING_UNIT * 16}px`,    // 64px
  20: `${SPACING_UNIT * 20}px`,    // 80px
  24: `${SPACING_UNIT * 24}px`,    // 96px
  32: `${SPACING_UNIT * 32}px`,    // 128px
};

// Layout spacing presets
export const layout = {
  // Page-level spacing
  page: {
    padding: {
      mobile: spacing[4],   // 16px
      tablet: spacing[6],   // 24px
      desktop: spacing[8],  // 32px
    },
    maxWidth: '1200px',
  },
  
  // Section spacing
  section: {
    paddingY: {
      sm: spacing[8],    // 32px
      base: spacing[12], // 48px
      lg: spacing[16],   // 64px
    },
    gap: spacing[8],     // 32px
  },
  
  // Component spacing
  component: {
    padding: {
      xs: spacing[2],    // 8px
      sm: spacing[3],    // 12px
      base: spacing[4],  // 16px
      lg: spacing[6],    // 24px
      xl: spacing[8],    // 32px
    },
    gap: {
      xs: spacing[1],    // 4px
      sm: spacing[2],    // 8px
      base: spacing[3],  // 12px
      lg: spacing[4],    // 16px
      xl: spacing[6],    // 24px
    },
  },
  
  // Grid system
  grid: {
    gap: {
      sm: spacing[4],    // 16px
      base: spacing[6],  // 24px
      lg: spacing[8],    // 32px
    },
  },
};

// Border radius tokens
export const radius = {
  none: '0',
  sm: '4px',
  base: '6px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  full: '9999px',
};

// Shadow tokens
export const shadows = {
  none: 'none',
  xs: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  sm: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
  base: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
  md: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
  lg: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
  xl: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  
  // Colored shadows
  brand: '0 4px 14px 0 rgba(37, 99, 235, 0.15)',
  error: '0 4px 14px 0 rgba(239, 68, 68, 0.15)',
  success: '0 4px 14px 0 rgba(34, 197, 94, 0.15)',
};

// Z-index scale
export const zIndex = {
  below: -1,
  base: 0,
  dropdown: 10,
  sticky: 20,
  fixed: 30,
  overlay: 40,
  modal: 50,
  popover: 60,
  tooltip: 70,
  notification: 80,
}; 